const fixVacancyUrl = (url?: string | null) => {
  // linkedin job search view
  if (url?.toLowerCase().match(/linkedin\.com\/jobs\/(search|collections\/recommended)/)) {
    try {
      // Parse the URL using the URL object
      const parsedUrl = new URL(url)

      // Get the 'currentJobId' query parameter
      const jobId = parsedUrl.searchParams.get("currentJobId")

      if (jobId) {
        // Construct the fixed LinkedIn job URL using the extracted job ID
        return `https://www.linkedin.com/jobs/view/${jobId}`
      } else {
        // If the 'currentJobId' query parameter is not found, return the original URL
        return url.trim()
      }
    } catch (error) {
      // If there's an error parsing the URL, return the original URL
      return url.trim()
    }
  }
  if (url?.toLowerCase().startsWith("https://www.indeed.com/jobs")) {
    const parsedUrl = new URL(url)
    const jobId = parsedUrl.searchParams.get("vjk")
    return `https://www.indeed.com/viewjob?jk=${jobId}`
  }

  if (url?.toLowerCase().match(/linkedin\.com\/jobs\/view\/\d+/)) {
    return url.split("?")[0]
  }

  return url?.trim()
}

export { fixVacancyUrl }
